module.exports = "https://r.zoocdn.com/_next/static/images/hero-320-20973eb001ffc3842c641db1ab624cbb.jpg";